import React, { useState } from 'react';
import AppHelmet from 'app/components/AppHelmet';
import SendRequestForm from 'app/components/Form/SendRequestForm';
import { FormattedMessage } from 'react-intl';
import './styles.scss';

const RequestDemoPage: React.FC = () => {
  const [productValue, setProductValue] = useState<string | null>(() => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('product');
  });

  return (
    <div className="requestDemo">
      <AppHelmet
        titleIntlID="requestDemoPage.metaTitle"
        descriptionIntlID="requestDemoPage.metaDesc"
      />
      <div className="container">
        <h1 className="requestDemo__title">
          <FormattedMessage id="requestDemoPage.title" />
        </h1>
        <SendRequestForm requestType="demo" product={productValue} />
      </div>
    </div>
  );
};

export default RequestDemoPage;
